import type { AuthorizedDealer } from 'models/authorizedDealer';
import { getSenderCountry } from 'selectors/entities/order/order';
import { getRecipientId } from 'selectors/entities/recipient/recipient';
import { getSelectedOfferId } from 'selectors/ui/ui';
import { indiaAuthorizedDealer } from 'services/payex/india/authorizedDealer';
import type { PayexThunkAction } from 'store/configureStore';

export const fetchAuthorizedDealer =
  (): PayexThunkAction<Promise<AuthorizedDealer | null>> =>
  (_dispatch, getState) => {
    const state = getState();
    const senderCountry = getSenderCountry(state);
    const recipientId = getRecipientId(state);
    const selectedOfferId = getSelectedOfferId(state);

    if (!senderCountry || !recipientId || !selectedOfferId) {
      return Promise.resolve(null);
    }

    return indiaAuthorizedDealer.fetch({
      sender_country: senderCountry,
      recipient_id: recipientId,
      offer: { id: selectedOfferId },
    });
  };
